module.exports = __webpack_public_path__ + "img/bumper.dc3db610.svg";